module.exports = __webpack_public_path__ + "media/images/icon-accordion-opened-1d92cb439da438c7e5482380c33ae9ae.svg";